import { EventEmitter, Injectable } from '@angular/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import * as CryptoJS from 'crypto-es';
import { environment } from 'src/environments/environment';
import { merge } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SystemInfoService {
  constructor(
    private afs: AngularFirestore) {

  }

 

  machineMapping() {
    
    return this.afs.collection('machine_mapping').snapshotChanges().pipe(map(doc => {
      let newDate = new Date
      return doc.map(obj => {

        return {
          ...obj.payload.doc.data() as object,
          dbid: obj.payload.doc.id,
        }
      })
    }))

  }

  getLastPing(systemId){
    return this.afs.collection('ping_response', ref => ref.where('systemId', '==', systemId).orderBy('createdAt','desc').limit(1)).snapshotChanges().pipe(map(doc => {
      return doc.map(obj => {

        return {
          ...obj.payload.doc.data() as object,
          dbid: obj.payload.doc.id,
        }
        
        
      })
    }))
  }

  systemInfo() {

    return this.afs.collection('system_info').snapshotChanges().pipe(map(doc => {
      let newDate = new Date
      return doc.map(obj => {

        return {
          ...obj.payload.doc.data() as object,
          dbid: obj.payload.doc.id,
        }
      })
    }))

  }

  saveAttachments(att){
    return this.afs.collection('attachments').add(att);
  }
  saveContacts(att){
    return this.afs.collection('contacts').add(att);
  }
  getAttachments(systemId){
    return this.afs.collection('attachments', ref => ref.where('systemId', '==', systemId)).snapshotChanges().pipe(map(doc => {
      return doc.map(obj => {

        return {
          ...obj.payload.doc.data() as object,
          dbid: obj.payload.doc.id,
        }
      })
    }))
  }

  saveNotes(att){
    return this.afs.collection('notater').add(att);
  }
  getNotes(systemId){
    return this.afs.collection('notater', ref => ref.where('systemId', '==', systemId)).snapshotChanges().pipe(map(doc => {
      return doc.map(obj => {

        return {
          ...obj.payload.doc.data() as object,
          dbid: obj.payload.doc.id,
        }
      })
    }))
  }

  getContacts(systemId){
    return this.afs.collection('kunder', ref => ref.where('systemId', '==', systemId)).snapshotChanges().pipe(map(doc => {
      return doc.map(obj => {

        return {
          ...obj.payload.doc.data() as object,
          dbid: obj.payload.doc.id,
        }
      })
    }))
  }
  // update(data){
  //  this.afs.doc(`/company/${data.companyId}/sites/${data.siteId}/systems/${data.systemId}`).get().subscribe(doc=>{
  //    let spData = doc.data();
  //    console.log(spData)
  //    this.afs.collection('machine_mapping').doc(data.dbid).update({systemName:spData['name']})

  //   })
  // }


}
